/**
 * Creates a Google Maps URL from either an address object or individual address components
 *
 * @param address - Either an address object with address_line_1, address_line_2, city, state, zip_code properties
 *                 OR a string with the complete address
 * @param cityState - Optional city/state string (used when address is a string)
 * @returns Google Maps URL with the address as a search query
 */
export const createGoogleMapsUrl = (
  address:
    | string
    | {
        address_line_1?: string;
        address_line_2?: string;
        city?: string;
        state?: string;
        zip_code?: string;
      },
  cityState?: string
): string => {
  let fullAddress = '';

  if (typeof address === 'string') {
    // Handle string address (used in ProfileCenterDetails)
    fullAddress = `${address} ${cityState || ''}`.trim();
  } else {
    // Handle address object (used in AddressDisplay)
    const addressLine1 = address.address_line_1 || '';
    const addressLine2 = address.address_line_2 || '';
    const city = address.city || '';
    const state = address.state || '';
    const zipCode = address.zip_code || '';

    fullAddress =
      `${addressLine1} ${addressLine2} ${city} ${state} ${zipCode}`.trim();
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    fullAddress
  )}`;
};
